﻿module Client.ContractPage.PurchaseOrders.RequestModal

open FSharpPlus
open Fable.React
open Fable.React.Props
open Fulma
open PortalLibs.Client.Components
open PortalLibs.Client.Util
open Model
open ContractPageModel
open Fable.Core
open Fable.Core.JsInterop
open PortalLibs.Shared
open System

[<Import("default", from = "@date-io/date-fns")>]
let DateFnsUtils: obj = jsNative

[<Import("MuiPickersUtilsProvider", from = "@material-ui/pickers")>]
let MuiPickersUtilsProvider: obj = jsNative

[<Import("TimePicker", from = "@material-ui/pickers")>]
let TimePicker: obj = jsNative

[<Import("DatePicker ", from = "@material-ui/pickers")>]
let DatePicker: obj = jsNative

let View model (contract: Contract) dispatch =

  Modal.modal [ Modal.IsActive(Option.isSome model.PurchaseOrderRequest) ] [
    Modal.background [ Props [
                         OnClick(fun _ -> None |> RequestPurchaseOrderContractId |> dispatch)
                       ] ] []
    Modal.Card.card [ Props [ Style [ MaxWidth "500px" ] ] ] [
      Modal.Card.head [] [
        Modal.Card.title [] [
          "Request Purchase Order" |> str
        ]
        Delete.delete [ Delete.OnClick(fun _ -> None |> RequestPurchaseOrderContractId |> dispatch) ] []
      ]
      Modal.Card.body [] [
        div [ Style [ MaxWidth "450px" ] ] [
          Heading.h5 [] [
            $"%s{Option.emptyStrIfNone contract.Number} - %s{Option.emptyStrIfNone contract.Description}"
            |> str
          ]
          Field.div [] [
            Label.label [] [ str "Description" ]
            Control.div [] [
              Input.text [
                Input.ValueOrDefault(
                  model.PurchaseOrderRequest
                  |>> (fun o -> o.Description)
                  |> Option.emptyStrIfNone
                )
                Input.OnChange
                  (fun e ->
                    model.PurchaseOrderRequest
                    |>> (fun r -> { (r: PurchaseOrderRequest) with Description = !!e.target?value })
                    |> PurchaseOrderRequestChanged
                    |> dispatch)
              ]
            ]
          ]
          Field.div [] [
            Label.label [] [ str "Items needed" ]
            Control.div [] [
              Multiline.Multiline
                {| Mode =
                     Multiline.ReadWrite
                       { ValueChanged =
                           (fun value ->
                             model.PurchaseOrderRequest
                             |>> (fun r -> { (r: PurchaseOrderRequest) with Items = value })
                             |> PurchaseOrderRequestChanged
                             |> dispatch)
                         Spellcheck = false }
                   Value =
                     (model.PurchaseOrderRequest
                      |>> (fun o -> o.Items)
                      |> Option.emptyStrIfNone)
                   Key = "PurchaseOrderItems"
                   Rows = Some 3
                   MaxRows = Some 6
                   Ref = None |}

            ]
          ]
          Field.div [] [
            Label.label [] [
              str "Preferred Vendor"
            ]
            Control.div [] [
              Input.text [
                Input.ValueOrDefault(
                  model.PurchaseOrderRequest
                  |>> (fun o -> o.Vendor)
                  |> Option.emptyStrIfNone
                )
                Input.OnChange
                  (fun e ->
                    model.PurchaseOrderRequest
                    |>> (fun r -> { (r: PurchaseOrderRequest) with Vendor = !!e.target?value })
                    |> PurchaseOrderRequestChanged
                    |> dispatch)
              ]
            ]
          ]
          Field.div [] [
            Label.label [] [
              str "Location for Delivery"
            ]
            Control.div [] [
              Input.text [
                Input.ValueOrDefault(
                  model.PurchaseOrderRequest
                  |>> (fun o -> o.Location)
                  |> Option.emptyStrIfNone
                )
                Input.OnChange
                  (fun e ->
                    model.PurchaseOrderRequest
                    |>> (fun r -> { r with Location = !!e.target?value })
                    |> PurchaseOrderRequestChanged
                    |> dispatch)
              ]
            ]
          ]
          Field.div [] [
            Label.label [] [ str "Needed by" ]
            Control.div [] [
              let date =
                match model.PurchaseOrderRequest with
                | None -> DateTime.Now
                | Some r -> r.Date

              let utilsProviderProps = createObj [ "utils" => DateFnsUtils ]

              let datePickerProps =
                createObj [
                  "value" => date
                  "onChange"
                  => fun date ->
                       model.PurchaseOrderRequest
                       |>> (fun r -> { (r: PurchaseOrderRequest) with Date = date })
                       |> PurchaseOrderRequestChanged
                       |> dispatch
                ]

              yield
                ofImport
                  "MuiPickersUtilsProvider"
                  "@material-ui/pickers"
                  utilsProviderProps
                  [ div [ Style [
                            Display DisplayOptions.Flex
                            JustifyContent "space-between"
                          ] ] [
                      div [ Style [ MarginRight "5px" ] ] [
                        ofImport "DatePicker" "@material-ui/pickers" datePickerProps []
                      ]
                      ofImport "TimePicker" "@material-ui/pickers" datePickerProps []
                    ] ]
            ]
          ]
        ]
      ]
      Modal.Card.foot [] [
        Button.button [ Button.Color IsSuccess
                        Button.OnClick
                          (fun _ ->
                            model.PurchaseOrderRequest
                            |> SendPurchaseOrderRequest
                            |> dispatch) ] [
          str "Send"
        ]
        Button.button [ Button.OnClick(fun _ -> None |> RequestPurchaseOrderContractId |> dispatch) ] [
          str "Cancel"
        ]
      ]
    ]
  ]